import { mobileMax, tabletMin } from '@propertypal/shared/src/constants/mediaQueries';
import styled, { css } from 'styled-components';
import { TextProps, applyProps } from '../../typography';

export const Container = styled.div<{ $bg: string }>`
  background-color: ${({ $bg }) => $bg};
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 16px;
  @media (${tabletMin}) {
    padding: 24px;
  }
`;

export const ContentContainer = styled.div`
  margin-bottom: 16px;
`;

export const ContentFill = styled.div<{ $fillBg?: string }>`
  ${({ $fillBg }) =>
    $fillBg
      ? css`
          background-color: ${$fillBg};
        `
      : ''};
`;

export const DevSection = styled.div<{ $bg?: string }>`
  ${({ $bg }) =>
    $bg
      ? css`
          background-color: ${$bg};
        `
      : ''};
  margin-bottom: 16px;
`;

export const Content = styled.div<{ $narrow?: boolean }>`
  width: 100%;
  max-width: ${({ $narrow }) => ($narrow ? 985 : 1280)}px;
  margin: 0 auto;
  padding: 16px;
  @media (${tabletMin}) {
    padding: 24px;
  }
`;

export const DevHeaderImg = styled.img<{ mb?: number }>`
  width: 100%;

  ${({ mb }) =>
    mb
      ? css`
          margin-bottom: ${mb}px;
        `
      : ''};
`;

export const DevTitleImg = styled.img<{ maxW?: number }>`
  margin-bottom: 16px;

  ${({ maxW }) =>
    maxW
      ? css`
          max-width: ${maxW}px;
          width: 100%;
        `
      : ''};
`;

export const DevImgGrid = styled.div`
  margin-bottom: 16px;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-column-gap: 16px;
  grid-row-gap: 16px;

  img {
    width: 100%;
  }

  @media (${mobileMax}) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`;

export const DevUnorderdList = styled.ul<TextProps>`
  padding-left: 17px;
  li {
    ${applyProps}
  }
`;
